import React, { useState, useEffect, useRef } from 'react';
import testimonialImage from '../../assets/images/user.png'
import StarRating from './StarRating'
// import '../../pages/home/homePage.css';
import './responsive.css';
import './style.css';


interface Feedback {
    comment_by: string;
    designation: string;
    comments: string;
}

interface TestimonialsProps {
    feedbackList: Feedback[];
}



const Feedbacks = () => {
    const [feedbackList, setFeedbackList] = useState<any[]>([]);
    //   const [carouselItems, setCarouselItems] = useState(appliances);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;


    

    const fetchFeedbackList = async () => {
        try {
            const response = await fetch(`${backendUrl}${version}All-feedbacks`, 
              {  method: 'GET',
                headers:{
                  // Accept:'aplication/json',
                  "Content-Type": "application/json",
          
                },
                credentials: "include",
                mode:"cors"

                                          
              }
          );
            const data = await response.json();
               // Log the data to inspect its structure

            if (Array.isArray(data.data)) {
              const flattenedData = data.data.flat();
                
                setFeedbackList(flattenedData);
            } else {
                // console.warn('Expected data to be an array but received:', data);
                setFeedbackList([]); // Default to empty array if not an array
            }
        } catch (error) {
            //console.error('Error fetching feedback data:', error);
            setFeedbackList([]); // Default to empty array in case of error
        }
    };
    useEffect(() => {
        fetchFeedbackList();
    }, []);

    return (
      <section className="testimonials">
        <div className="container">
          <div className="ourPartner text-center">
            <h2 className="headingText">
            Trusted by Over 1,50,000 Customers
            </h2>
          </div>
          {feedbackList.length > 0 && <div className="owl-carousel testi owl-theme">
            {feedbackList.map((feedback, index) => (
              <div className="item" key={index}>
                <div className="google_wrap mb-3 d-flex">
                 <div className="post_img d-flex align-items-center">
                 <img
                      src={feedback.feedback_profile_img }
                      onError={(e) => {
                        (e.currentTarget as HTMLImageElement).src = testimonialImage;
                      }}
                      alt={feedback.comment_by+index}
                    />
                    <div className="post_name_date ">
                      <p className="post_name">{feedback.comment_by}</p>
                      {/* <p className="post_date"> {feedback.designation}</p> */}
                    </div>
                  </div>
                  <div className="google_icon"><img src="/images/Google_icon.png" alt="Rating" /></div>
                  </div>
                <div className="post_top_rating_wrap d-flex align-items-center justify-content-between">                 
                <StarRating rating={feedback.rating}/>
                </div>

                <div className="bottom_txt">
                  <p>{feedback.comments}</p>
                </div>
           
              </div>
              
            ))}
            <div className="item view_all_reviews ">
               <div className="google_icon"><img src="/images/Google_icon.png" alt="Rating" style={{ maxWidth: "28px" }} /></div>
              <p className="view_all_link">
              <a target='_blank' href="https://www.google.com/maps/place/Selsmart/@28.6117723,77.3641919,15z/data=!3m1!4b1!4m6!3m5!1s0x824d9fd1375f6b5:0xe968f84fdec20af1!8m2!3d28.6117727!4d77.3744916!16s%2Fg%2F11w49ll3xg?entry=ttu&g_ep=EgoyMDI1MDYyMy4yIKXMDSoASAFQAw%3D%3D">View All Reviews</a></p>
              </div>
          </div>
          }

        </div>
      </section>
    );
};

export default Feedbacks;
